/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeRight = createReactComponent("outline", "arrow-badge-right", "IconArrowBadgeRight", [["path", { "d": "M13 7h-6l4 5l-4 5h6l4 -5z", "key": "svg-0" }]]);

export { IconArrowBadgeRight as default };
//# sourceMappingURL=IconArrowBadgeRight.mjs.map
